import {styled} from '@mui/system';

import zoomPalette from 'zoomPalette';

export const NewFeatBadge = styled('span')(({theme}) => ({
  marginRight: '4px',
  padding: '0px 4px',
  width: '36px',
  height: '16px',
  borderRadius: '3px 6px',
  backgroundColor: zoomPalette.blue['60'],

  fontWeight: 450,
  fontSize: '12px',
  lineHeight: '16px',
  textAlign: 'center',
  color: 'white',
}));
